import { render } from "./AdminDateChangeStatus.vue?vue&type=template&id=3563bc60"
import script from "./AdminDateChangeStatus.vue?vue&type=script&lang=js"
export * from "./AdminDateChangeStatus.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__